<template>
  <div class="mobileWrapper consentPageBg">
    <div class="text-center">
      <img
        :src="logoImg"
        alt="Logo"
      >
    </div>
    <b-row>
      <b-col cols="12">
        <div class="myInfo">
          <div class="rtr-Icon">
            <span>
              <img :src="assignmentImg">
              <i>
                <img :src="errorIcon">
              </i>
            </span>
          </div>
          <div class="rtrInfoContent mismatch-block">
            <h2 class="mb-75">
              Your NRIC does not seem to match our records for this Transfer Request.
            </h2>
            <p>Please try again with the Singpass for <strong>NRIC ending “{{ this.$route.query.nric }}”</strong>.</p>
            <div class="singpass-btn-cs floatCss">
              <b-button
                class="ms-btn"
                @click="goBack"
              >
                Try again
              </b-button>
            </div>
            <div class="singpass-btn-cs floatCss">
              <b-button
                :to="'/appointments'"
                class="sbs-cancel-btn"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoImg: require('@/assets/images/frontend/logo-slim.png'),
      // eslint-disable-next-line global-require
      assignmentImg: require('@/assets/images/file-transfer/assignment_ind.svg'),
      // eslint-disable-next-line global-require
      errorIcon: require('@/assets/images/file-transfer/error-icon.svg'),
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'file-transfer-landing', params: { token: this.$route.params.token } })
    },
  },
}
</script>
